module.exports = __webpack_public_path__ + "static/media/icon-pa.05597016.png";